import { t } from 'i18next';

import { ErrorResponseErrorItemCodeIntegrationKey } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeIntegrationKey, string> => ({
  'integration_key:missing': t('integrationKey.missing', {
    ns: 'apiErrorCodes',
    defaultValue: 'Integrationsnyckeln saknas.',
  }),
  'integration_key:invalid': t('integrationKey.invalid', {
    ns: 'apiErrorCodes',
    defaultValue: 'Integrationsnyckeln är inte giltig.',
  }),
});
